import { useCallback, useMemo } from 'react';
import { useRxData } from 'rxdb-hooks';

import { isJestTest } from '../../test-helpers/isJestTest';
import { sortByStepNo } from '../../utilities/sortHelper';
import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import useAssetDetails from '../assetDetails/useAssetDetails';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { PmCheckList, PmCheckListCollection } from './queryBuilder';

const usePmCheckList = (site: number) => {
  const { result: assetDetails } = useAssetDetails();
  const getPmChecklistQuery = useCallback(
    (collection: PmCheckListCollection) => {
      return collection?.find({
        selector: {
          assetCategoryId: isJestTest()
            ? Number(getValueFromLocalStorage('assetCategoryId'))
            : assetDetails?.assetCategoryId,
          inspectionTypeName: getValueFromLocalStorage('inspectionType'),
          isActive: true,
          site,
        },
      });
    },
    [site, assetDetails],
  );

  const { result } = useRxData<PmCheckList>(RxdbCollectionName.PM_CHECKLIST, getPmChecklistQuery, {
    json: true,
  });

  const pmCheckListLookUpData = useMemo(() => {
    const loookupData: PmCheckList[] = result?.sort(sortByStepNo)?.map(mainStep => {
      return {
        ...mainStep,
        children: JSON.parse(JSON.stringify(mainStep?.children || '[]'))?.sort(sortByStepNo),
      };
    });
    return loookupData || [];
  }, [result]);

  return { pmCheckListLookUpData };
};

export default usePmCheckList;
